import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from '@angular/http';
import { FormsModule } from "@angular/forms";
import { CabeceraModule } from "../../../components/common/cabecera/cabecera.module";
import { DataTableModule } from "angular2-datatable";
import { Ng2Bs3ModalModule } from "ng2-bs3-modal/ng2-bs3-modal";
import { Ng2Webstorage } from "ngx-webstorage/dist/app";
import { ExclusionOtros } from "./solicitud-otros.component";
import { ExclusionOtrosService } from "./solicitud-otros.service";
import {FileUploadModule} from "ng2-file-upload/ng2-file-upload";

@NgModule({
    declarations: [ExclusionOtros],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        CabeceraModule,
        DataTableModule,
        Ng2Bs3ModalModule,
        Ng2Webstorage,
        FileUploadModule],
    providers: [ExclusionOtrosService],
    exports: [ExclusionOtros]

})

export class SolicitudOtrosModule { }


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/solicitudes/solicitud-otros.module.ts